import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Create Location
 * @type {function(type: string): {type: string, payload: any}}
 */
export const locationCreateRequest = simpleAction(TYPES.LOCATION_CREATE_REQUEST);

/**
 * Create Location Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const locationCreateSuccess = simpleAction(TYPES.LOCATION_CREATE_SUCCESS);

/**
 * Create Location Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const locationCreateError = simpleAction(TYPES.LOCATION_CREATE_FAIL);

/**
 * Create Location Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const locationCreateDone = simpleAction(TYPES.LOCATION_CREATE_DONE);
